/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAgreementContactNote } from './ServiceAgreementContactNote';
import {
    ServiceAgreementContactNoteFromJSON,
    ServiceAgreementContactNoteFromJSONTyped,
    ServiceAgreementContactNoteToJSON,
    ServiceAgreementContactNoteToJSONTyped,
} from './ServiceAgreementContactNote';

/**
 * 
 * @export
 * @interface ServiceAgreementContactNotesResponse
 */
export interface ServiceAgreementContactNotesResponse {
    /**
     * Contact notes associated with the service agreement
     * @type {Array<ServiceAgreementContactNote>}
     * @memberof ServiceAgreementContactNotesResponse
     */
    contactNotes?: Array<ServiceAgreementContactNote>;
}

/**
 * Check if a given object implements the ServiceAgreementContactNotesResponse interface.
 */
export function instanceOfServiceAgreementContactNotesResponse(value: object): value is ServiceAgreementContactNotesResponse {
    return true;
}

export function ServiceAgreementContactNotesResponseFromJSON(json: any): ServiceAgreementContactNotesResponse {
    return ServiceAgreementContactNotesResponseFromJSONTyped(json, false);
}

export function ServiceAgreementContactNotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementContactNotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contactNotes': json['contactNotes'] == null ? undefined : ((json['contactNotes'] as Array<any>).map(ServiceAgreementContactNoteFromJSON)),
    };
}

export function ServiceAgreementContactNotesResponseToJSON(json: any): ServiceAgreementContactNotesResponse {
    return ServiceAgreementContactNotesResponseToJSONTyped(json, false);
}

export function ServiceAgreementContactNotesResponseToJSONTyped(value?: ServiceAgreementContactNotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactNotes': value['contactNotes'] == null ? undefined : ((value['contactNotes'] as Array<any>).map(ServiceAgreementContactNoteToJSON)),
    };
}

